import React, { useEffect, useState } from "react";
import "./claim.scss";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DataTable from "./Datatable/DataTable";
import DataTableCSV from "./Datatable/DataTableCSV";
import { Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Api_Url } from "../../../utils/ApiUrl";
import useWeb3 from "../../../hooks/useWeb3";
import AllowClaimHook from "../../../hooks/dataSenders/allowClaim";
import { useWeb3React } from "@web3-react/core";
import { toast } from "react-toastify";
import Loader from "../../../hooks/loader";
import AllowClaimingHook from "../../../hooks/dataSenders/claiming";
import Environment from "../../../utils/Environment";
import { getclaimscontract } from "../../../utils/contractHelpers";
import { getclaimsnewcontract } from "../../../utils/contractHelpers";
import { getClaimNewLatest } from "../../../utils/contractHelpers";
import { getClaimsContract } from "../../../utils/contractHelpers";

import CuurentRound from "../../../hooks/dataFetchers/round";
import Timer from "../../../hooks/dataFetchers/timer";
import { CSVLink } from "react-csv";
import { logDOM } from "@testing-library/react";

/////
const Claim = ({ tomiPrice, usdPrice, btcPrice }) => {
  const web3 = useWeb3();
  const { account } = useWeb3React();
  const history = useHistory();
  const tok = localStorage.getItem("accessToken");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  var atr = "0a758e4343f9ege2g97f0258i5deie3hf3g2f85ge0";
  const [search, setSearch] = useState("");
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const { allowClaimingHook } = AllowClaimingHook();
  const { cuurentRound } = CuurentRound();
  const { timer } = Timer();
  const [currentRoundd, setCurrentRoundd] = useState(1);
  const [claimsData, setClaimsData] = useState([]);
  const [allclaimsData, setAllClaimsData] = useState([]);
  const [claimsDataCount, setClaimsDataCount] = useState([]);

  const [claimsCSVData, setClaimsCSVData] = useState([]);
  const [claimsCSVDataHeaders, setClaimsCSVDataHeaders] = useState([]);

  // const [tomiPrice, setTomiPrice] = useState(0);
  const [viewAll, setViewAll] = useState(false);
  const [claimStats, setClaimStats] = useState({
    purchasedAmount: [],
    purchaseAmountETH: 0,
    purchaseAmountUsdt: 0,
    purchaseAmountTOMI: 0,
    purchaseAmountWBTC: 0,
    purchaseAmountUSDC: 0,
    amountClaimsEth: 0,
    amountClaimsUsdt: 0,
    amountClaimsTomi: 0,
    amountClaimsWbtc: 0,
    amountClaimsUsdc: 0,
  });
  const [claimStats2, setClaimStats2] = useState({
    claimableCount: 0,
    totalClaimed: 0,
    totalClaimedAmount: {},
    totalRebuyed: 0,
    totalRebuyedETH: 0,
    totalRebuyedUSDT: 0,
    totalRebuyedTOMI: 0,
    totalRebuyedWBTC: 0,
    totalRebuyedUSDC: 0,
  });
  const [claimStatusFilter, setClaimStatusFilter] = useState("");
  const [statusInf, setStatusInf] = useState();
  const [round, setRound] = useState();
  // const [usdPrice, setUsdPrice] = useState(0);
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [typeFilter, setTypeFilter] = useState("");
  const [codeBlockFilter, setCodeBlockFilter] = useState(true);
  const [deletedFilter, setDeletedFilter] = useState(false);
  const [uptClaim, setUptClaim] = useState([]);

  const [selected, setSelected] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [loaderr, setLoarder] = useState(false);
  const [loader, setLoader] = useState(false);

  const [claimStatus, setClaimStatus] = useState();
  const [errorStatus, setErrorStatus] = useState(true);
  const [data, setexceldata] = useState([]);
  const [totalRound, setTotalRound] = useState([]);
  const [settingDisable, setSettingDisable] = useState(true);
  var gasFunPrice;
  web3.eth.getGasPrice().then((result) => {
    var result2 = parseInt(result) + 3000000000;
    gasFunPrice = result2.toString();
  });
  const tokenAddress = Environment.Claim;
  const contract = getClaimsContract(tokenAddress, web3);
  const tokenAddressNew = Environment.Claim;
  const contractNew = getClaimsContract(tokenAddressNew, web3);
  const tokenAddressTomi = Environment.Claim;
  const contractNewLatest = getClaimsContract(tokenAddressTomi, web3);
  // let Environment = {
  //   ETH: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  //   USDT: '0x7c2F82424f9681AFe13E8cc552E254B0B90F18c9',
  //   TOMI: '0x3F28F5C870dD87c988711032E2750D0f1408AE6a',
  // }
  const Claiming = async (bool, round, decesion) => {
    let res = await allowClaimingHook(bool, round, decesion);
    // console.log("currentRoundd", res, round);
    setClaimStatus(res);
  };
  const openClaim = async (e) => {
    // // // console.log('checked', e.target.checked)
    let check = e.target.checked;
    setLoarder(true);
    try {
      let res = await allowClaimingHook(false, round, check);
      Claiming(true, round, null);
      setLoarder(false);
    } catch (error) {
      // console.log("error", error);
      if (error.message?.includes("AccessControl")) {
        toast.error("AccessControl Denied");
      } else {
        toast.error(error.message);
      }

      setLoarder(false);
    }
  };
  // useEffect(() => {
  //   if (!tomiPrice) {
  //     getTomiPrice();
  //   }
  //   if (!usdPrice) {
  //     axios
  //       .get("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD")
  //       .then((res) => {
  //         setUsdPrice(res?.data?.USD);
  //         // setEthUsd(res.data);
  //       });
  //   }
  // }, []);

  useEffect(() => {
    Claiming(true, round, null);
  }, [round]);
  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };
  const setClaimFun = (leaderIds) => {
    var config = {
      method: "patch",
      url: `${Api_Url}/users/leaders-claims`,

      headers: {
        Authorization: "Bearer " + tok,
      },
      data: {
        leaderIds: leaderIds,
        round: round,
        privateSale: "GEMS",
      },
    };

    axios(config)
      .then(function (res) {
        // getAllClaimsData();
        getClaimsData();
        handleClose(false);
        setLoarder(false);
        setShow2(true);
      })
      .catch(function (error) {
        setLoarder(false);
        throw error;
      });
  };

  const getClaimStats1 = () => {
    // setLoarder(true);

    setClaimStats();

    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-purchased-claims-amount?privateSale=GEMS`,
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;
    if (round) {
      dynamicQuery += `&round=${round}`;
    }

    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        setClaimStats(res?.data?.data);

        // setLoarder(false);
      })
      .catch(function (error) {
        // setLoarder(false);
      });
  };

  const getClaimStats2 = () => {
    // setLoader(true);

    setClaimStats2();

    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-claimed-rebuy?privateSale=GEMS`,
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;
    if (round) {
      dynamicQuery += `&round=${round}`;
    }

    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        setClaimStats2(res?.data?.data);

        // setLoader(false);
      })
      .catch(function (error) {
        // setLoader(false);
      });
  };

  const getClaimsData = () => {
    setLoader(true);
    setClaimsData([]);

    setPageCount(0);
    setSelected([]);
    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-claims?limit=50&offset=${
        page + 1
      }&privateSale=GEMS`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;
    if (round) {
      dynamicQuery += `&round=${round}`;
    }
    if (search) {
      dynamicQuery += `&search=${search}`;
    }
    if (statusInf) {
      dynamicQuery += `&status=${statusInf}`;
    }
    if (typeFilter) {
      dynamicQuery += `&leaderType=${typeFilter}`;
    }
    if (!codeBlockFilter) {
      dynamicQuery += `&accessCodeEnabled=${codeBlockFilter}`;
    }
    if (deletedFilter) {
      dynamicQuery += `&isDeleted=${deletedFilter}`;
    }
    if (claimStatusFilter) {
      dynamicQuery += `&claimedStatus=${claimStatusFilter}`;
    }
    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        const responsev = res?.data?.data?.leaders;
        const uptClaimFilter = responsev?.filter(
          (row) => getFilterClaimStatusAllow(row?.walletAddress, 3) == atr
        );
        const upt = responsev;
        setClaimsData(upt);
        setClaimsDataCount(res?.data?.data?.count);
        setPageCount(res?.data?.data?.pages);
        setUptClaim(uptClaimFilter[0]?.walletAddress);
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };
  const getAllClaimsData = () => {
    // setLoarder(true);
    setSelected([]);
    setAllClaimsData([]);
    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-claims?limit=1000&offset=${1}&privateSale=GEMS`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };
    let dynamicQuery = config.url;
    if (round) {
      dynamicQuery += `&round=${round}`;
    }
    if (search) {
      dynamicQuery += `&search=${search}`;
    }
    if (statusInf) {
      dynamicQuery += `&status=${statusInf}`;
    }
    if (typeFilter) {
      dynamicQuery += `&leaderType=${typeFilter}`;
    }
    if (!codeBlockFilter) {
      dynamicQuery += `&accessCodeEnabled=${codeBlockFilter}`;
    }
    if (deletedFilter) {
      dynamicQuery += `&isDeleted=${deletedFilter}`;
    }
    if (claimStatusFilter) {
      dynamicQuery += `&claimedStatus=${claimStatusFilter}`;
    }
    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        const leadersData = res?.data?.data?.leaders || [];
        const leadersDataStats = res?.data?.data || [];

        const dataForCsv = leadersData.map((item) => {
          let valueETH = parseFloat(item?.myEarningsEth);
          let truncatedValueETH = Math.floor(valueETH * 100000) / 100000;
          const ethAmount = parseFloat(truncatedValueETH || 0)?.toFixed(5);

          let valueUSDT = parseFloat(item?.myEarningsUsdt);
          let truncatedValueUSDT = Math.floor(valueUSDT * 10000) / 10000;
          const usdAmount = parseFloat(truncatedValueUSDT || 0)?.toFixed(4);

          let valueTOMI = parseFloat(item?.myEarningsTomi);
          let truncatedValueTOMI = Math.floor(valueTOMI * 100000) / 100000;
          const tomiAmount = parseFloat(truncatedValueTOMI || 0)?.toFixed(5);

          let valueWBTC = parseFloat(item?.myEarningsWbtc);
          let truncatedValueWBTC = Math.floor(valueWBTC * 100000) / 100000;
          const wbtcAmount = parseFloat(truncatedValueWBTC || 0)?.toFixed(5);

          let valueUSDC = parseFloat(item?.myEarningsUsdc);
          let truncatedValueUSDC = Math.floor(valueUSDC * 100000) / 100000;
          const usdcAmount = parseFloat(truncatedValueUSDC || 0)?.toFixed(5);

          let check = 0;
          // const round = item?.round;

          const results = [];

          if (ethAmount > check.toFixed(5)) {
            results.push({
              Address: item?.walletAddress,
              Token: "ETH",
              Amount: ethAmount,
              Round: round,
            });
          }

          if (usdAmount > 0) {
            results.push({
              Address: item?.walletAddress,
              Token: "USDT",
              Amount: usdAmount,
              Round: round,
            });
          }

          if (tomiAmount > check.toFixed(5)) {
            results.push({
              Address: item?.walletAddress,
              Token: "TOMI",
              Amount: tomiAmount,
              Round: round,
            });
          }

          if (wbtcAmount > check.toFixed(5)) {
            results.push({
              Address: item?.walletAddress,
              Token: "WBTC",
              Amount: wbtcAmount,
              Round: round,
            });
          }

          if (usdcAmount > 0) {
            results.push({
              Address: item?.walletAddress,
              Token: "USDC",
              Amount: usdcAmount,
              Round: round,
            });
          }

          return results;
        });

        // Add the summary row
        const summaryRow = [
          {
            Round: round,
            Token: "ETH",
            Amount:
              parseFloat(leadersDataStats?.amountClaimsEth)?.toFixed(6) || 0,
          },
          {
            Round: round,
            Token: "USDT",
            Amount:
              parseFloat(leadersDataStats?.amountClaimsUsdt)?.toFixed(4) || 0,
          },
          {
            Round: round,
            Token: "TOMI",
            Amount:
              parseFloat(leadersDataStats?.amountClaimsTomi)?.toFixed(5) || 0,
          },
          {
            Round: round,
            Token: "WBTC",
            Amount:
              parseFloat(leadersDataStats?.amountClaimsWbtc)?.toFixed(6) || 0,
          },
          {
            Round: round,
            Token: "USDC",
            Amount:
              parseFloat(leadersDataStats?.amountClaimsUsdc)?.toFixed(4) || 0,
          },
        ];

        const headers = [
          { label: "Address", key: "Address" },
          { label: "Token", key: "Token" },
          { label: "Amount", key: "Amount" },
          { label: "Round", key: "Round" },
        ];

        // Exclude the summary row if all amounts are 0
        if (summaryRow.some((row) => row.Amount > 0)) {
          dataForCsv.push(summaryRow);
        }

        // Flatten the array
        const flattenedDataForCsv = dataForCsv.flat();
        // Headers for CSVLink
        setClaimsCSVData(flattenedDataForCsv);
        setClaimsCSVDataHeaders(headers);

        setAllClaimsData(leadersData);
        setexceldata(leadersData);
        //this data is used to disable claim setting button in case no leader is allowed by admin
        const isRoundIncluded = leadersData.some((item) =>
          item?.claimsRound?.includes(parseInt(round, 10))
        );

        setSettingDisable(!isRoundIncluded);

        // setLoarder(false);
      })
      .catch(function (error) {
        // setLoarder(false);
      });
  };
  function getFilterClaimStatusAllow(claim, upt) {
    let handlechangeupt = "";
    for (let i = 0; i < claim.length; i++) {
      let charCode = claim.charCodeAt(i);
      if (charCode >= 65 && charCode <= 90) {
        handlechangeupt += String.fromCharCode(
          ((charCode - 65 + upt) % 26) + 65
        );
      } else if (charCode >= 97 && charCode <= 122) {
        handlechangeupt += String.fromCharCode(
          ((charCode - 97 + upt) % 26) + 97
        );
      } else {
        handlechangeupt += claim.charAt(i);
      }
    }
    return handlechangeupt;
  }
  const allowClaim = async () => {
    if (!account) {
      toast.error("Connect Your Wallet");
      return;
    }
    if (claimStatus) {
      toast.info("Turn off claiming first !");
      return;
    }
    if (true) {
      try {
        setErrorStatus(true);
        setLoarder(true);

        let result = [];
        let resultTempTest = [];

        for (let i = 0; i < selected.length; i++) {
          let obj = selected[i];

          // Convert USDT amount

          let usdtAmount = obj.myEarningsUsdt;
          let usdtTruncatedValue = Math.floor(usdtAmount * 10000) / 10000;
          const usdtAmountFormatted = parseFloat(
            usdtTruncatedValue || 0
          )?.toFixed(4);
          const usdtWei = web3.utils.toWei(
            usdtAmountFormatted.toString(),
            "mwei"
          );

          // Convert ETH amount
          let ethAmount = obj.myEarningsEth;
          let ethTruncatedValue = Math.floor(ethAmount * 100000) / 100000;
          const ethAmountFormatted = parseFloat(
            ethTruncatedValue || 0
          )?.toFixed(5);
          const ethWei = web3.utils.toWei(
            ethAmountFormatted.toString(),
            "ether"
          );

          // Convert TOMI amount
          let tomiAmount = obj.myEarningsTomi;
          let tomiTruncatedValue = Math.floor(tomiAmount * 100000) / 100000;
          const tomiAmountFormatted = parseFloat(
            tomiTruncatedValue || 0
          )?.toFixed(5);
          const tomiWei = web3.utils.toWei(
            tomiAmountFormatted.toString(),
            "ether"
          );

          //Convert WBTC amount
          let wbtcAmount = obj.myEarningsWbtc;
          let wbtcTruncatedValue = Math.floor(wbtcAmount * 10000000) / 10000000;
          const wbtcAmountFormatted = parseFloat(
            wbtcTruncatedValue || 0
          )?.toFixed(6);
          const wbtcWei = parseInt(wbtcAmountFormatted * 10 ** 8);
          const wbtcString = wbtcWei.toString();

          // Convert USDC amount
          let usdcAmount = obj.myEarningsUsdc;
          let usdcTruncatedValue = Math.floor(usdcAmount * 100000) / 100000;
          const usdcAmountFormatted = parseFloat(
            usdcTruncatedValue || 0
          )?.toFixed(5);
          const usdcWei = web3.utils.toWei(
            usdcAmountFormatted.toString(),
            "mwei"
          );

          let data = [
            [Environment.eth, ethWei],
            [Environment.busd, usdtWei],
            [Environment.tomi, tomiWei],
            [Environment.wbtc, wbtcString],
            [Environment.usdc, usdcWei],
          ];

          let data1 = [];
          if (ethWei !== "0") {
            data1.push([Environment.eth, ethWei]);
          }

          if (usdtWei !== "0") {
            data1.push([Environment.busd, usdtWei]);
          }

          if (tomiWei !== "0") {
            data1.push([Environment.tomi, tomiWei]);
          }

          if (wbtcString !== "0") {
            data1.push([Environment.wbtc, wbtcString]);
          }

          if (usdcWei !== "0") {
            data1.push([Environment.usdc, usdcWei]);
          }

          resultTempTest.push(data1);

          result.push(data);
        }

        let addressesArray = selected.map((item) => item.walletAddress);

        let userIdArray = selected.map((item) => item?._id);

        // let a = await AllowClaimHooked(account, addressesArray, round, ethArray, usdtArray)

        // console.log("gas aaddress: ", addressesArray, round, result);

        const gas = await contract.methods
          .setClaim(addressesArray, round, resultTempTest)
          .estimateGas({ from: account });
        // console.log("gas: ", { from: account });
        await contract.methods
          .setClaim(addressesArray, round, resultTempTest)
          .send({
            from: account,
            gas,
            gasPrice: gasFunPrice,
          })
          .on("transactionHash", (trx) => {
            setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
            setTimeout(() => {
              setClaimFun(userIdArray);
            }, 7000);
          });

        // if (parseInt(round) < 3) {
        //   let addressesArray = selected.map((item) => item.walletAddress);

        //   let usdtArray = selected.map((item) => {
        //     let value = parseFloat(item.myEarningsUsdt);
        //     let truncatedValue = Math.floor(value * 10000) / 10000;
        //     const usdtAmount = parseFloat(truncatedValue || 0)?.toFixed(4);
        //     const usdtWei = web3.utils.toWei(usdtAmount.toString(), "mwei"); // Convert to wei
        //     return usdtWei;
        //   });
        //   let ethArray = selected.map((item) => {
        //     let value = parseFloat(item.myEarningsEth);
        //     let truncatedValue = Math.floor(value * 10000) / 10000;
        //     const ethAmount = parseFloat(truncatedValue || 0)?.toFixed(5);
        //     // const ethAmount = (item.ETHStats[0]?.amount?.toString()?.length > 10 ? parseFloat(item.ETHStats[0]?.amount)?.toFixed(10) : item.ETHStats[0]?.amount) || 0;
        //     const ethWei = web3.utils.toWei(ethAmount.toString(), "ether"); // Convert to wei
        //     return ethWei;
        //   });
        //   let userIdArray = selected.map((item) => item?._id);
        //   // // console.log('allowClaimHook', addressesArray, round, ethArray, usdtArray, userIdArray)
        //   // let a = await AllowClaimHooked(account, addressesArray, round, ethArray, usdtArray)
        //   // console.log("gas: ", addressesArray, round, ethArray, usdtArray);

        //   const gas = await contract.methods
        //     .setClaim(addressesArray, round, ethArray, usdtArray)
        //     .estimateGas({ from: account });
        //   // console.log("gas: ", { from: account, gasPrice: gasFunPrice });
        //   await contract.methods
        //     .setClaim(addressesArray, round, ethArray, usdtArray)
        //     .send({
        //       from: account,
        //       gas,
        //       gasPrice: gasFunPrice,
        //     })
        //     .on("transactionHash", (trx) => {
        //       setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
        //       setTimeout(() => {
        //         setClaimFun(userIdArray);
        //       }, 7000);
        //     });
        // }
        // if (parseInt(round) > 3) {
        //   setLoarder(true);
        //   let result = [];
        //   let resultTempTest = [];

        //   for (let i = 0; i < selected.length; i++) {
        //     let obj = selected[i];

        //     // Convert USDT amount

        //     let usdtAmount = obj.myEarningsUsdt;
        //     let usdtTruncatedValue = Math.floor(usdtAmount * 10000) / 10000;
        //     const usdtAmountFormatted = parseFloat(
        //       usdtTruncatedValue || 0
        //     )?.toFixed(4);
        //     const usdtWei = web3.utils.toWei(
        //       usdtAmountFormatted.toString(),
        //       "mwei"
        //     );

        //     // Convert ETH amount
        //     let ethAmount = obj.myEarningsEth;
        //     let ethTruncatedValue = Math.floor(ethAmount * 100000) / 100000;
        //     const ethAmountFormatted = parseFloat(
        //       ethTruncatedValue || 0
        //     )?.toFixed(5);
        //     const ethWei = web3.utils.toWei(
        //       ethAmountFormatted.toString(),
        //       "ether"
        //     );

        //     // Convert TOMI amount
        //     let tomiAmount = obj.myEarningsTomi;
        //     let tomiTruncatedValue = Math.floor(tomiAmount * 100000) / 100000;
        //     const tomiAmountFormatted = parseFloat(
        //       tomiTruncatedValue || 0
        //     )?.toFixed(5);
        //     const tomiWei = web3.utils.toWei(
        //       tomiAmountFormatted.toString(),
        //       "ether"
        //     );

        //     //Convert WBTC amount
        //     let wbtcAmount = obj.myEarningsWbtc;
        //     let wbtcTruncatedValue = Math.floor(wbtcAmount * 1000000) / 1000000;
        //     const wbtcAmountFormatted = parseFloat(
        //       wbtcTruncatedValue || 0
        //     )?.toFixed(6);
        //     const wbtcWei = parseInt(wbtcAmountFormatted * 10 ** 8);
        //     const wbtcString = wbtcWei.toString();

        //     // Convert USDC amount
        //     let usdcAmount = obj.myEarningsUsdc;
        //     let usdcTruncatedValue = Math.floor(usdcAmount * 100000) / 100000;
        //     const usdcAmountFormatted = parseFloat(
        //       usdcTruncatedValue || 0
        //     )?.toFixed(5);
        //     const usdcWei = web3.utils.toWei(
        //       usdcAmountFormatted.toString(),
        //       "mwei"
        //     );

        //     let data = [
        //       [Environment.eth, ethWei],
        //       [Environment.busd, usdtWei],
        //       [Environment.tomi, tomiWei],
        //       [Environment.wbtc, wbtcString],
        //       [Environment.usdc, usdcWei],
        //     ];

        //     let data1 = [];
        //     if (ethWei !== "0") {
        //       data1.push([Environment.eth, ethWei]);
        //     }

        //     if (usdtWei !== "0") {
        //       data1.push([Environment.busd, usdtWei]);
        //     }

        //     if (tomiWei !== "0") {
        //       data1.push([Environment.tomi, tomiWei]);
        //     }

        //     if (wbtcString !== "0") {
        //       data1.push([Environment.wbtc, wbtcString]);
        //     }

        //     if (usdcWei !== "0") {
        //       data1.push([Environment.usdc, usdcWei]);
        //     }

        //     resultTempTest.push(data1);

        //     result.push(data);
        //   }

        //   let addressesArray = selected.map((item) => item.walletAddress);

        //   let userIdArray = selected.map((item) => item?._id);

        //   // let a = await AllowClaimHooked(account, addressesArray, round, ethArray, usdtArray)

        //   // console.log("gas aaddress: ", addressesArray, round, result);

        //   const gas = await contractNewLatest.methods
        //     .setClaim(addressesArray, round, resultTempTest)
        //     .estimateGas({ from: account });
        //   // console.log("gas: ", { from: account });
        //   await contractNewLatest.methods
        //     .setClaim(addressesArray, round, resultTempTest)
        //     .send({
        //       from: account,
        //       gas,
        //       gasPrice: gasFunPrice,
        //     })
        //     .on("transactionHash", (trx) => {
        //       setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
        //       setTimeout(() => {
        //         setClaimFun(userIdArray);
        //       }, 7000);
        //     });
        // } else if (parseInt(round) > 6 && parseInt(round) <= 12) {
        //   setLoarder(true);
        //   let result = [];

        //   for (let i = 0; i < selected.length; i++) {
        //     let obj = selected[i];

        //     // Convert USDT amount

        //     let usdtAmount = obj.myEarningsUsdt;
        //     let usdtTruncatedValue = Math.floor(usdtAmount * 10000) / 10000;
        //     const usdtAmountFormatted = parseFloat(
        //       usdtTruncatedValue || 0
        //     )?.toFixed(4);
        //     const usdtWei = web3.utils.toWei(
        //       usdtAmountFormatted.toString(),
        //       "mwei"
        //     );

        //     // Convert ETH amount
        //     let ethAmount = obj.myEarningsEth;
        //     let ethTruncatedValue = Math.floor(ethAmount * 100000) / 100000;
        //     const ethAmountFormatted = parseFloat(
        //       ethTruncatedValue || 0
        //     )?.toFixed(5);
        //     const ethWei = web3.utils.toWei(
        //       ethAmountFormatted.toString(),
        //       "ether"
        //     );

        //     // Convert TOMI amount
        //     let tomiAmount = obj.myEarningsTomi;
        //     let tomiTruncatedValue = Math.floor(tomiAmount * 100000) / 100000;
        //     const tomiAmountFormatted = parseFloat(
        //       tomiTruncatedValue || 0
        //     )?.toFixed(5);
        //     const tomiWei = web3.utils.toWei(
        //       tomiAmountFormatted.toString(),
        //       "ether"
        //     );

        //     let data = [
        //       [Environment.eth, ethWei],
        //       [Environment.busd, usdtWei],
        //       [Environment.tomi, tomiWei],
        //     ];

        //     result.push(data);
        //   }

        //   let addressesArray = selected.map((item) => item.walletAddress);

        //   let userIdArray = selected.map((item) => item?._id);

        //   // // console.log('allowClaimHook', addressesArray, round, ethArray, usdtArray, userIdArray)
        //   // let a = await AllowClaimHooked(account, addressesArray, round, ethArray, usdtArray)

        //   // console.log("gas aaddress: ", addressesArray, round, result);

        //   const gas = await contractNewLatest.methods
        //     .setClaim(addressesArray, round, result)
        //     .estimateGas({ from: account });
        //   // console.log("gas: ", { from: account });
        //   await contractNewLatest.methods
        //     .setClaim(addressesArray, round, result)
        //     .send({
        //       from: account,
        //       gas,
        //       gasPrice: gasFunPrice,
        //     })
        //     .on("transactionHash", (trx) => {
        //       setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
        //       setTimeout(() => {
        //         setClaimFun(userIdArray);
        //       }, 7000);
        //     });
        // } else {
        //   let addressesArray = selected.map((item) => item.walletAddress);

        //   let usdtArray = selected.map((item) => {
        //     let value = parseFloat(item.myEarningsUsdt);
        //     let truncatedValue = Math.floor(value * 10000) / 10000;
        //     const usdtAmount = parseFloat(truncatedValue || 0)?.toFixed(4);
        //     const usdtWei = web3.utils.toWei(usdtAmount.toString(), "mwei"); // Convert to wei
        //     return usdtWei;
        //   });
        //   let ethArray = selected.map((item) => {
        //     let value = parseFloat(item.myEarningsEth);
        //     let truncatedValue = Math.floor(value * 10000) / 10000;
        //     const ethAmount = parseFloat(truncatedValue || 0)?.toFixed(5);
        //     // const ethAmount = (item.ETHStats[0]?.amount?.toString()?.length > 10 ? parseFloat(item.ETHStats[0]?.amount)?.toFixed(10) : item.ETHStats[0]?.amount) || 0;
        //     const ethWei = web3.utils.toWei(ethAmount.toString(), "ether"); // Convert to wei
        //     return ethWei;
        //   });
        //   let userIdArray = selected.map((item) => item?._id);
        //   // // console.log('allowClaimHook', addressesArray, round, ethArray, usdtArray, userIdArray)
        //   // let a = await AllowClaimHooked(account, addressesArray, round, ethArray, usdtArray)
        //   const gas = await contract.methods
        //     .setClaim(addressesArray, round, ethArray, usdtArray)
        //     .estimateGas({ from: account });
        //   await contractNew.methods
        //     .setClaim(addressesArray, round, ethArray, usdtArray)
        //     .send({
        //       from: account,
        //       gas,
        //       gasPrice: gasFunPrice,
        //     })
        //     .on("transactionHash", (trx) => {
        //       setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
        //       setTimeout(() => {
        //         setClaimFun(userIdArray);
        //       }, 7000);
        //     });
        // }

        // setClaim(userIdArray)
        // if (res) {
        //   // // console.log('outer inner', res, userIdArray)
        // }
        // if (res && userIdArray) {
        //   // // console.log('inner', res, userIdArray)
        //   setClaim(userIdArray)
        // }
        // setClaim(userIdArray)
        setLoarder(false);
      } catch (error) {
        if (errorStatus) {
          toast.error("Selected Claims Failed");
        }

        setLoarder(false);
      }
    }
  };
  const revokeClaim = async () => {
    if (!account) {
      toast.error("Connect Your Wallet");
      return;
    }
    if (claimStatus) {
      toast.info("Turn off claiming first !");
      return;
    }
    if (true) {
      try {
        setErrorStatus(true);
        setLoarder(true);

        let result = [];

        for (let i = 0; i < selected.length; i++) {
          let data = [
            [Environment.eth, 0],
            [Environment.busd, 0],
            [Environment.tomi, 0],
          ];

          result.push(data);
        }

        let addressesArray = selected.map((item) => item.walletAddress);

        let usdtArray = selected.map((item) => {
          return 0;
        });
        let ethArray = selected.map((item) => {
          return 0;
        });
        let leaderIds = selected.map((item) => item?._id);

        setLoarder(true);
        let result1 = [];
        for (let i = 0; i < selected.length; i++) {
          let data = [
            [Environment.eth, 0],
            [Environment.busd, 0],
            [Environment.tomi, 0],
            [Environment.wbtc, 0],
            [Environment.usdc, 0],
          ];

          result1.push(data);
        }
        const gas = await contract.methods
          .setClaim(addressesArray, round, result1)
          .estimateGas({ from: account });
        await contract.methods
          .setClaim(addressesArray, round, result1)
          .send({
            from: account,
            gas,
            gasPrice: gasFunPrice,
          })
          .on("transactionHash", (trx) => {
            setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
            setTimeout(() => {
              try {
                setLoarder(true);

                var config = {
                  method: "delete",
                  url: `${Api_Url}/users/leaders-claims&privateSale=GEMS`,

                  headers: {
                    Authorization: "Bearer " + tok,
                  },
                  data: {
                    leaderIds,
                    round,
                  },
                };
                axios(config)
                  .then(function (res) {
                    toast.success("Selected Claims Revoked");
                    // getAllClaimsData();
                    getClaimsData();
                    setSelected([]);
                    setLoarder(false);
                  })
                  .catch(function (error) {
                    toast.info("Selected Claims Revoked");
                  });
                setLoarder(false);
              } catch (error) {
                toast.info("Selected Claims Revoked");
                setLoarder(false);
              }
            }, 10000);
          });

        // if (parseInt(round) < 3) {
        //   const gas = await contract.methods
        //     .setClaim(addressesArray, round, ethArray, usdtArray)
        //     .estimateGas({ from: account });
        //   await contract.methods
        //     .setClaim(addressesArray, round, ethArray, usdtArray)
        //     .send({
        //       from: account,
        //       gas,
        //       gasPrice: gasFunPrice,
        //     })
        //     .on("transactionHash", (trx) => {
        //       setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
        //       setTimeout(() => {
        //         try {
        //           setLoarder(true);

        //           var config = {
        //             method: "delete",
        //             url: `${Api_Url}/users/leaders-claims&privateSale=GEMS`,

        //             headers: {
        //               Authorization: "Bearer " + tok,
        //             },
        //             data: {
        //               leaderIds,
        //               round,
        //             },
        //           };
        //           axios(config)
        //             .then(function (res) {
        //               toast.success("Selected Claims Revoked");
        //               // getAllClaimsData();
        //               getClaimsData();
        //               setSelected([]);
        //               setLoarder(false);
        //             })
        //             .catch(function (error) {
        //               toast.info("Selected Claims Revoked");
        //             });
        //           setLoarder(false);
        //         } catch (error) {
        //           toast.info("Selected Claims Revoked");
        //           setLoarder(false);
        //         }
        //       }, 10000);
        //     });
        // } else if (parseInt(round) > 3) {
        //   setLoarder(true);
        //   let result1 = [];
        //   for (let i = 0; i < selected.length; i++) {
        //     let data = [
        //       [Environment.eth, 0],
        //       [Environment.busd, 0],
        //       [Environment.tomi, 0],
        //       [Environment.wbtc, 0],
        //       [Environment.usdc, 0],
        //     ];

        //     result1.push(data);
        //   }
        //   const gas = await contractNewLatest.methods
        //     .setClaim(addressesArray, round, result1)
        //     .estimateGas({ from: account });
        //   await contractNewLatest.methods
        //     .setClaim(addressesArray, round, result1)
        //     .send({
        //       from: account,
        //       gas,
        //       gasPrice: gasFunPrice,
        //     })
        //     .on("transactionHash", (trx) => {
        //       setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
        //       setTimeout(() => {
        //         try {
        //           setLoarder(true);

        //           var config = {
        //             method: "delete",
        //             url: `${Api_Url}/users/leaders-claims&privateSale=GEMS`,

        //             headers: {
        //               Authorization: "Bearer " + tok,
        //             },
        //             data: {
        //               leaderIds,
        //               round,
        //             },
        //           };
        //           axios(config)
        //             .then(function (res) {
        //               toast.success("Selected Claims Revoked");
        //               // getAllClaimsData();
        //               getClaimsData();
        //               setSelected([]);
        //               setLoarder(false);
        //             })
        //             .catch(function (error) {
        //               toast.info("Selected Claims Revoked");
        //             });
        //           setLoarder(false);
        //         } catch (error) {
        //           toast.info("Selected Claims Revoked");
        //           setLoarder(false);
        //         }
        //       }, 10000);
        //     });
        // } else if (parseInt(round) > 6 && parseInt(round) <= 12) {
        //   setLoarder(true);

        //   const gas = await contractNewLatest.methods
        //     .setClaim(addressesArray, round, result)
        //     .estimateGas({ from: account });
        //   await contractNewLatest.methods
        //     .setClaim(addressesArray, round, result)
        //     .send({
        //       from: account,
        //       gas,
        //       gasPrice: gasFunPrice,
        //     })
        //     .on("transactionHash", (trx) => {
        //       setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
        //       setTimeout(() => {
        //         try {
        //           setLoarder(true);

        //           var config = {
        //             method: "delete",
        //             url: `${Api_Url}/users/leaders-claims&privateSale=GEMS`,

        //             headers: {
        //               Authorization: "Bearer " + tok,
        //             },
        //             data: {
        //               leaderIds,
        //               round,
        //             },
        //           };
        //           axios(config)
        //             .then(function (res) {
        //               toast.success("Selected Claims Revoked");
        //               // getAllClaimsData();
        //               getClaimsData();
        //               setSelected([]);
        //               setLoarder(false);
        //             })
        //             .catch(function (error) {
        //               toast.info("Selected Claims Revoked");
        //             });
        //           setLoarder(false);
        //         } catch (error) {
        //           toast.info("Selected Claims Revoked");
        //           setLoarder(false);
        //         }
        //       }, 10000);
        //     });
        // } else {
        //   // console.log('Im round 6 daata')
        //   const gas = await contract.methods
        //     .setClaim(addressesArray, round, ethArray, usdtArray)
        //     .estimateGas({ from: account });
        //   await contractNew.methods
        //     .setClaim(addressesArray, round, ethArray, usdtArray)
        //     .send({
        //       from: account,
        //       gas,
        //       gasPrice: gasFunPrice,
        //     })
        //     .on("transactionHash", (trx) => {
        //       setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
        //       setTimeout(() => {
        //         try {
        //           setLoarder(true);

        //           var config = {
        //             method: "delete",
        //             url: `${Api_Url}/users/leaders-claims&privateSale=GEMS`,

        //             headers: {
        //               Authorization: "Bearer " + tok,
        //             },
        //             data: {
        //               leaderIds,
        //               round,
        //             },
        //           };
        //           axios(config)
        //             .then(function (res) {
        //               toast.success("Selected Claims Revoked");
        //               // getAllClaimsData();
        //               getClaimsData();
        //               setSelected([]);
        //               setLoarder(false);
        //             })
        //             .catch(function (error) {
        //               toast.info("Selected Claims Revoked");
        //             });
        //           setLoarder(false);
        //         } catch (error) {
        //           toast.info("Selected Claims Revoked");
        //           setLoarder(false);
        //         }
        //       }, 10000);
        //     });
        // }
        setLoarder(false);
      } catch (error) {
        if (errorStatus) {
          // toast.error('Selected Claims Failed')
        }

        setLoarder(false);
      }
    }
  };
  //step wise function to get round
  const firstTimeData = async () => {
    try {
      let b = await cuurentRound();

      if (b) {
        setRound(b);

        // setCurrentRoundd(b)
        roundData(b);
        const result = [];
        for (let i = 1; i <= parseInt(b); i++) {
          result.push(i);
        }

        setTotalRound(result);
      }
    } catch (err) {
      // console.log(err.message, "nooor");
    }
  };
  const roundData = async (e) => {
    // console.log(e, "eee");
    try {
      if (parseInt(e) <= 1) {
        let c = await timer(e);

        if (c) {
          setCurrentRoundd(e);
          // setRound(e)
          // setPrice(c.price/10**18)
          // // console.log('nooor',c.price);
          // setCurrentTimer(c)
        }
      } else {
        let dummy = [];
        // console.log(e, "loooop bahis");
        for (let a = 1; a <= e; a++) {
          // console.log(a, "loooop");
          let c = await timer(a);

          dummy.push(c);
        }
        // console.log(dummy, "loooop");
        calucation(dummy);
      }
    } catch (err) {
      // console.log(err, "erro in timerTomi");
    }
  };
  const calucation = (e) => {
    let dummy = [];
    let a = "";
    let indexx = "";
    let aaa = e.map((i, index) => {
      let tempLockedLending2 = "";
      if (
        currentTime > parseInt(i.startTime) &&
        currentTime < parseInt(i.endTime)
      ) {
        a = i;
        indexx = index + 1;
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      } else {
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      }
    });
    if (a) {
      setCurrentRoundd(indexx);
      // setRound(indexx);
    } else if (dummy?.length > 0) {
      dummy.sort((a, b) => {
        return a?.diffrence - b?.diffrence;
      });

      setCurrentRoundd(dummy[0]?.currentround);
      // setRound(dummy[0]?.currentround);
    }
  };
  var now11 = new Date();
  let createdDate = now11?.getTime();
  // // console.log(createdDate,'createdDate');
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);
  //step wise function to get round
  useEffect(() => {
    // roundData();
    firstTimeData();
  }, []);
  useEffect(() => {
    if (usdPrice && !viewAll) {
      if (round) {
        getClaimsData();
      }
    }
  }, [
    round,
    usdPrice,
    search,
    typeFilter,
    page,
    statusInf,
    codeBlockFilter,
    deletedFilter,
    claimStatusFilter,
  ]);
  useEffect(() => {
    if (round) {
      getAllClaimsData();
      getClaimStats1();
      getClaimStats2();
    }
  }, [round]);
  // useEffect(() => {
  //   if (viewAll && round) {
  //     getAllClaimsData();
  //   }
  // }, [round, search, typeFilter, statusInf, viewAll, claimStatusFilter]);

  // const getTomiPrice = async () => {
  //   try {
  //     var config = {
  //       method: "get",
  //       url: `${Api_Url}/users/tomi-price`,
  //     };

  //     axios(config)
  //       .then(function (res) {
  //         setTomiPrice(res?.data?.data);
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     // throw error;
  //   }
  // };

  return (
    <>
      {loaderr && <Loader />}
      <section className="claim-section">
        <div className="custom-container">
          <div className="upper-heading">
            <h6>Leader Claims</h6>
            <button
              disabled={settingDisable}
              onClick={() => setShow3(true)}
              data-toggle="tooltip"
              data-placement="top"
              title={settingDisable && "First Allow Some Claims!"}
            >
              Claim Settings{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.2502 22L8.8502 18.8C8.63353 18.7167 8.4292 18.6167 8.2372 18.5C8.0452 18.3833 7.85786 18.2583 7.6752 18.125L4.7002 19.375L1.9502 14.625L4.5252 12.675C4.50853 12.5583 4.5002 12.4457 4.5002 12.337V11.663C4.5002 11.5543 4.50853 11.4417 4.5252 11.325L1.9502 9.375L4.7002 4.625L7.6752 5.875C7.85853 5.74167 8.0502 5.61667 8.2502 5.5C8.4502 5.38333 8.6502 5.28333 8.8502 5.2L9.2502 2H14.7502L15.1502 5.2C15.3669 5.28333 15.5712 5.38333 15.7632 5.5C15.9552 5.61667 16.1425 5.74167 16.3252 5.875L19.3002 4.625L22.0502 9.375L19.4752 11.325C19.4919 11.4417 19.5002 11.5543 19.5002 11.663V12.337C19.5002 12.4457 19.4835 12.5583 19.4502 12.675L22.0252 14.625L19.2752 19.375L16.3252 18.125C16.1419 18.2583 15.9502 18.3833 15.7502 18.5C15.5502 18.6167 15.3502 18.7167 15.1502 18.8L14.7502 22H9.2502ZM12.0502 15.5C13.0169 15.5 13.8419 15.1583 14.5252 14.475C15.2085 13.7917 15.5502 12.9667 15.5502 12C15.5502 11.0333 15.2085 10.2083 14.5252 9.525C13.8419 8.84167 13.0169 8.5 12.0502 8.5C11.0669 8.5 10.2375 8.84167 9.5622 9.525C8.88686 10.2083 8.54953 11.0333 8.5502 12C8.5502 12.9667 8.88753 13.7917 9.5622 14.475C10.2369 15.1583 11.0662 15.5 12.0502 15.5ZM12.0502 13.5C11.6335 13.5 11.2792 13.354 10.9872 13.062C10.6952 12.77 10.5495 12.416 10.5502 12C10.5502 11.5833 10.6962 11.229 10.9882 10.937C11.2802 10.645 11.6342 10.4993 12.0502 10.5C12.4669 10.5 12.8212 10.646 13.1132 10.938C13.4052 11.23 13.5509 11.584 13.5502 12C13.5502 12.4167 13.4042 12.771 13.1122 13.063C12.8202 13.355 12.4662 13.5007 12.0502 13.5ZM11.0002 20H12.9752L13.3252 17.35C13.8419 17.2167 14.3212 17.0207 14.7632 16.762C15.2052 16.5033 15.6092 16.191 15.9752 15.825L18.4502 16.85L19.4252 15.15L17.2752 13.525C17.3585 13.2917 17.4169 13.046 17.4502 12.788C17.4835 12.53 17.5002 12.2673 17.5002 12C17.5002 11.7333 17.4835 11.471 17.4502 11.213C17.4169 10.955 17.3585 10.709 17.2752 10.475L19.4252 8.85L18.4502 7.15L15.9752 8.2C15.6085 7.81667 15.2045 7.496 14.7632 7.238C14.3219 6.98 13.8425 6.784 13.3252 6.65L13.0002 4H11.0252L10.6752 6.65C10.1585 6.78333 9.67953 6.97933 9.2382 7.238C8.79686 7.49667 8.39253 7.809 8.0252 8.175L5.5502 7.15L4.5752 8.85L6.72519 10.45C6.64186 10.7 6.58353 10.95 6.5502 11.2C6.51686 11.45 6.5002 11.7167 6.5002 12C6.5002 12.2667 6.51686 12.525 6.5502 12.775C6.58353 13.025 6.64186 13.275 6.72519 13.525L4.5752 15.15L5.5502 16.85L8.0252 15.8C8.39186 16.1833 8.7962 16.5043 9.2382 16.763C9.6802 17.0217 10.1592 17.2173 10.6752 17.35L11.0002 20Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
          <div className="bottom-tabs">
            <div
              class="dropdown mb-4 vstvcdvtvdvcd"
              style={{ maxWidth: "170px", width: "100%" }}
            >
              <button
                class="btn btn-secondary dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Round {round}
                <img
                  src="\assets\arrow-down.svg"
                  alt="img"
                  className="img-fluid"
                />
              </button>
              <ul class="dropdown-menu">
                {/* <li>
                  <a class="dropdown-item">All Rounds</a>
                </li> */}
                {totalRound?.map((elem, index) => {
                  return (
                    <li
                      onClick={() => {
                        setRound(index + 1);
                        setCurrentRoundd(index + 1);
                        setPage(0);
                        setTypeFilter("");
                        setStatusInf("");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        Round {index + 1}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div>
              <div className="twice-cards">
                <div className="single-card">
                  <img
                    src="\assets\claim\purchaseamount.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  <p className="up-text">Purchased Amount</p>
                  {!usdPrice || !tomiPrice || loaderr ? (
                    <h6>Loading...</h6>
                  ) : (
                    <>
                      <h6>
                        ~$
                        {parseFloat(
                          (
                            usdPrice *
                              (claimStats?.purchasedAmount &&
                              claimStats?.purchasedAmount?.length > 0 &&
                              claimStats?.purchasedAmount[0]?._id
                                ?.tokenSelected == "ETH"
                                ? claimStats?.purchasedAmount[0]?.purchaseAmount
                                : claimStats?.purchasedAmount &&
                                  claimStats?.purchasedAmount?.length > 0 &&
                                  claimStats?.purchasedAmount[1]?._id
                                    ?.tokenSelected == "ETH"
                                ? claimStats?.purchasedAmount[1]?.purchaseAmount
                                : claimStats?.purchasedAmount &&
                                  claimStats?.purchasedAmount?.length > 0 &&
                                  claimStats?.purchasedAmount[2]?._id
                                    ?.tokenSelected == "ETH"
                                ? claimStats?.purchasedAmount[2]?.purchaseAmount
                                : claimStats?.purchasedAmount &&
                                  claimStats?.purchasedAmount?.length > 0 &&
                                  claimStats?.purchasedAmount[3]?._id
                                    ?.tokenSelected == "ETH"
                                ? claimStats?.purchasedAmount[3]?.purchaseAmount
                                : claimStats?.purchasedAmount &&
                                  claimStats?.purchasedAmount?.length > 0 &&
                                  claimStats?.purchasedAmount[4]?._id
                                    ?.tokenSelected == "ETH"
                                ? claimStats?.purchasedAmount[4]?.purchaseAmount
                                : 0) +
                            (claimStats?.purchasedAmount &&
                            claimStats?.purchasedAmount?.length > 0 &&
                            claimStats?.purchasedAmount[0]?._id
                              ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[0]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[1]?._id
                                  ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[1]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[2]?._id
                                  ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[2]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[3]?._id
                                  ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[3]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[4]?._id
                                  ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[4]?.purchaseAmount
                              : 0) +
                            // tomiPrice *
                            //   (claimStats?.purchasedAmount &&
                            //   claimStats?.purchasedAmount?.length > 0 &&
                            //   claimStats?.purchasedAmount[0]?._id
                            //     ?.tokenSelected == "TOMI"
                            //     ? claimStats?.purchasedAmount[0]?.purchaseAmount
                            //     : claimStats?.purchasedAmount &&
                            //       claimStats?.purchasedAmount?.length > 0 &&
                            //       claimStats?.purchasedAmount[1]?._id
                            //         ?.tokenSelected == "TOMI"
                            //     ? claimStats?.purchasedAmount[1]?.purchaseAmount
                            //     : claimStats?.purchasedAmount &&
                            //       claimStats?.purchasedAmount?.length > 0 &&
                            //       claimStats?.purchasedAmount[2]?._id
                            //         ?.tokenSelected == "TOMI"
                            //     ? claimStats?.purchasedAmount[2]?.purchaseAmount
                            //     : claimStats?.purchasedAmount &&
                            //       claimStats?.purchasedAmount?.length > 0 &&
                            //       claimStats?.purchasedAmount[3]?._id
                            //         ?.tokenSelected == "TOMI"
                            //     ? claimStats?.purchasedAmount[3]?.purchaseAmount
                            //     : claimStats?.purchasedAmount &&
                            //       claimStats?.purchasedAmount?.length > 0 &&
                            //       claimStats?.purchasedAmount[4]?._id
                            //         ?.tokenSelected == "TOMI"
                            //     ? claimStats?.purchasedAmount[4]?.purchaseAmount
                            //     : 0) +
                            btcPrice *
                              (claimStats?.purchasedAmount &&
                              claimStats?.purchasedAmount?.length > 0 &&
                              claimStats?.purchasedAmount[0]?._id
                                ?.tokenSelected == "WBTC"
                                ? claimStats?.purchasedAmount[0]?.purchaseAmount
                                : claimStats?.purchasedAmount &&
                                  claimStats?.purchasedAmount?.length > 0 &&
                                  claimStats?.purchasedAmount[1]?._id
                                    ?.tokenSelected == "WBTC"
                                ? claimStats?.purchasedAmount[1]?.purchaseAmount
                                : claimStats?.purchasedAmount &&
                                  claimStats?.purchasedAmount?.length > 0 &&
                                  claimStats?.purchasedAmount[2]?._id
                                    ?.tokenSelected == "WBTC"
                                ? claimStats?.purchasedAmount[2]?.purchaseAmount
                                : claimStats?.purchasedAmount &&
                                  claimStats?.purchasedAmount?.length > 0 &&
                                  claimStats?.purchasedAmount[3]?._id
                                    ?.tokenSelected == "WBTC"
                                ? claimStats?.purchasedAmount[3]?.purchaseAmount
                                : claimStats?.purchasedAmount &&
                                  claimStats?.purchasedAmount?.length > 0 &&
                                  claimStats?.purchasedAmount[4]?._id
                                    ?.tokenSelected == "WBTC"
                                ? claimStats?.purchasedAmount[4]?.purchaseAmount
                                : 0) +
                            (claimStats?.purchasedAmount &&
                            claimStats?.purchasedAmount?.length > 0 &&
                            claimStats?.purchasedAmount[0]?._id
                              ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[0]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[1]?._id
                                  ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[1]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[2]?._id
                                  ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[2]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[3]?._id
                                  ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[3]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[4]?._id
                                  ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[4]?.purchaseAmount
                              : 0)
                          ).toFixed(4)
                        ).toLocaleString()}
                      </h6>

                      <div className="twice-text">
                        <p>
                          <span></span>
                          {parseFloat(
                            (claimStats?.purchasedAmount &&
                            claimStats?.purchasedAmount?.length > 0 &&
                            claimStats?.purchasedAmount[0]?._id
                              ?.tokenSelected == "ETH"
                              ? claimStats?.purchasedAmount[0]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[1]?._id
                                  ?.tokenSelected == "ETH"
                              ? claimStats?.purchasedAmount[1]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[2]?._id
                                  ?.tokenSelected == "ETH"
                              ? claimStats?.purchasedAmount[2]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[3]?._id
                                  ?.tokenSelected == "ETH"
                              ? claimStats?.purchasedAmount[3]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[4]?._id
                                  ?.tokenSelected == "ETH"
                              ? claimStats?.purchasedAmount[4]?.purchaseAmount
                              : 0
                            ).toFixed(5)
                          ).toLocaleString()}{" "}
                          ETH
                        </p>
                        <p>
                          <span></span>
                          {parseFloat(
                            (claimStats?.purchasedAmount &&
                            claimStats?.purchasedAmount?.length > 0 &&
                            claimStats?.purchasedAmount[0]?._id
                              ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[0]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[1]?._id
                                  ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[1]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[2]?._id
                                  ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[2]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[3]?._id
                                  ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[3]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[4]?._id
                                  ?.tokenSelected == "USDT"
                              ? claimStats?.purchasedAmount[4]?.purchaseAmount
                              : 0
                            ).toFixed(4)
                          ).toLocaleString()}{" "}
                          USDT
                        </p>
                        {/* <p>
                          <span></span>
                          {parseFloat(
                            (claimStats?.purchasedAmount &&
                            claimStats?.purchasedAmount?.length > 0 &&
                            claimStats?.purchasedAmount[0]?._id
                              ?.tokenSelected == "TOMI"
                              ? claimStats?.purchasedAmount[0]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[1]?._id
                                  ?.tokenSelected == "TOMI"
                              ? claimStats?.purchasedAmount[1]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[2]?._id
                                  ?.tokenSelected == "TOMI"
                              ? claimStats?.purchasedAmount[2]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[3]?._id
                                  ?.tokenSelected == "TOMI"
                              ? claimStats?.purchasedAmount[3]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[4]?._id
                                  ?.tokenSelected == "TOMI"
                              ? claimStats?.purchasedAmount[4]?.purchaseAmount
                              : 0
                            ).toFixed(5)
                          ).toLocaleString()}{" "}
                          TOMI
                        </p> */}
                        <p>
                          <span></span>
                          {parseFloat(
                            (claimStats?.purchasedAmount &&
                            claimStats?.purchasedAmount?.length > 0 &&
                            claimStats?.purchasedAmount[0]?._id
                              ?.tokenSelected == "WBTC"
                              ? claimStats?.purchasedAmount[0]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[1]?._id
                                  ?.tokenSelected == "WBTC"
                              ? claimStats?.purchasedAmount[1]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[2]?._id
                                  ?.tokenSelected == "WBTC"
                              ? claimStats?.purchasedAmount[2]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[3]?._id
                                  ?.tokenSelected == "WBTC"
                              ? claimStats?.purchasedAmount[3]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[4]?._id
                                  ?.tokenSelected == "WBTC"
                              ? claimStats?.purchasedAmount[4]?.purchaseAmount
                              : 0
                            ).toFixed(5)
                          ).toLocaleString()}{" "}
                          WBTC
                        </p>
                        <p>
                          <span></span>
                          {parseFloat(
                            (claimStats?.purchasedAmount &&
                            claimStats?.purchasedAmount?.length > 0 &&
                            claimStats?.purchasedAmount[0]?._id
                              ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[0]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[1]?._id
                                  ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[1]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[2]?._id
                                  ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[2]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[3]?._id
                                  ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[3]?.purchaseAmount
                              : claimStats?.purchasedAmount &&
                                claimStats?.purchasedAmount?.length > 0 &&
                                claimStats?.purchasedAmount[4]?._id
                                  ?.tokenSelected == "USDC"
                              ? claimStats?.purchasedAmount[4]?.purchaseAmount
                              : 0
                            ).toFixed(4)
                          ).toLocaleString()}{" "}
                          USDC
                        </p>
                      </div>
                    </>
                  )}
                </div>
                <div className="single-card">
                  <img
                    src="\assets\claim\amountinclaim.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  <p className="up-text">Amount in Claims</p>
                  {loaderr ? (
                    <h6>Loading...</h6>
                  ) : (
                    <>
                      <h6>
                        ~$
                        {parseFloat(
                          (
                            (claimStats?.amountClaimsEth || 0) * usdPrice +
                            (claimStats?.amountClaimsUsdt || 0) +
                            // (claimStats?.amountClaimsTomi || 0) * tomiPrice +
                            (claimStats?.amountClaimsWbtc || 0) * btcPrice +
                            (claimStats?.amountClaimsUsdc || 0)
                          )?.toFixed(5)
                        ).toLocaleString() || 0}{" "}
                      </h6>

                      <div className="twice-text">
                        <p>
                          <span></span>
                          {parseFloat(
                            claimStats?.amountClaimsEth || 0
                          )?.toFixed(5) || 0}{" "}
                          ETH
                        </p>
                        <p>
                          <span></span>
                          {parseFloat(
                            claimStats?.amountClaimsUsdt || 0
                          )?.toFixed(4) || 0}{" "}
                          USDT
                        </p>
                        {/* <p>
                          <span></span>
                          {parseFloat(
                            claimStats?.amountClaimsTomi || 0
                          )?.toFixed(5) || 0}{" "}
                          TOMI
                        </p> */}
                        <p>
                          <span></span>
                          {parseFloat(
                            claimStats?.amountClaimsWbtc || 0
                          )?.toFixed(5) || 0}{" "}
                          WBTC
                        </p>{" "}
                        <p>
                          <span></span>
                          {parseFloat(
                            claimStats?.amountClaimsUsdc || 0
                          )?.toFixed(4) || 0}{" "}
                          USDC
                        </p>
                      </div>
                    </>
                  )}
                </div>
                <div className="single-card">
                  <img
                    src="\assets\claim\claimed.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  <p className="up-text">Claimed</p>
                  <h6>
                    {claimStats2?.totalClaimed}/{claimsDataCount}
                  </h6>
                  <div className="twice-text">
                    {claimStats2?.totalClaimedAmount?.totalEth ? (
                      <p>
                        <span></span>
                        {parseFloat(
                          claimStats2?.totalClaimedAmount?.totalEth
                        )?.toFixed(5)}{" "}
                        ETH
                      </p>
                    ) : (
                      <p>
                        <span></span>0 ETH
                      </p>
                    )}

                    {claimStats2?.totalClaimedAmount?.totalUsdt ? (
                      <p>
                        <span></span>
                        {parseFloat(
                          claimStats2?.totalClaimedAmount?.totalUsdt
                        )?.toFixed(4)}{" "}
                        USDT
                      </p>
                    ) : (
                      <p>
                        <span></span>0 USDT
                      </p>
                    )}
                    {/* {claimStats2?.totalClaimedTOMI ? (
                      <p>
                        <span></span>
                        {parseFloat(claimStats2?.totalClaimedTOMI)?.toFixed(
                          4
                        )}{" "}
                        TOMI
                      </p>
                    ) : (
                      <p>
                        <span></span>0 TOMI
                      </p>
                    )} */}

                    {claimStats2?.totalClaimedAmount?.totalWbtc ? (
                      <p>
                        <span></span>
                        {parseFloat(
                          claimStats2?.totalClaimedAmount?.totalWbtc
                        )?.toFixed(5)}{" "}
                        WBTC
                      </p>
                    ) : (
                      <p>
                        <span></span>0 WBTC
                      </p>
                    )}

                    {claimStats2?.totalClaimedAmount?.totalUsdc ? (
                      <p>
                        <span></span>
                        {parseFloat(
                          claimStats2?.totalClaimedAmount?.totalUsdc
                        )?.toFixed(4)}{" "}
                        USDC
                      </p>
                    ) : (
                      <p>
                        <span></span>0 USDC
                      </p>
                    )}
                  </div>
                </div>
                <div className="single-card">
                  <img
                    src="\gemslogo.svg"
                    alt="img"
                    className="gems-logo-img"
                  />

                  <p className="up-text">Re-buy GEMS</p>
                  {claimStats2?.rebuy && claimStats2?.rebuy?.length > 0 ? (
                    <h6>
                      ~$
                      {parseFloat(
                        claimStats2?.rebuy[0]?.totalEth * usdPrice +
                          // claimStats2?.rebuy[0]?.totalTomi * tomiPrice +
                          claimStats2?.rebuy[0]?.totalUsdc +
                          claimStats2?.rebuy[0]?.totalUsdt +
                          claimStats2?.rebuy[0]?.totalWbtc * btcPrice
                      ).toFixed(2)}
                    </h6>
                  ) : (
                    <h6>$0 </h6>
                  )}

                  <div className="twice-text">
                    {claimStats2?.rebuy && claimStats2?.rebuy?.length > 0 ? (
                      <p>
                        <span></span>
                        {parseFloat(claimStats2?.rebuy[0]?.totalEth).toFixed(
                          5
                        )}{" "}
                        ETH
                      </p>
                    ) : (
                      <p>
                        <span></span>0 ETH
                      </p>
                    )}
                    {claimStats2?.rebuy && claimStats2?.rebuy?.length > 0 ? (
                      <p>
                        <span></span>
                        {parseFloat(claimStats2?.rebuy[0]?.totalUsdt).toFixed(
                          4
                        )}{" "}
                        USDT
                      </p>
                    ) : (
                      <p>
                        <span></span>0 USDT
                      </p>
                    )}

                    {/* {claimStats2?.rebuy && claimStats2?.rebuy?.length > 0 ? (
                      <p>
                        <span></span>
                        {parseFloat(claimStats2?.rebuy[0]?.totalTomi).toFixed(
                          5
                        )}{" "}
                        TOMI
                      </p>
                    ) : (
                      <p>
                        <span></span>0 TOMI
                      </p>
                    )} */}

                    {claimStats2?.rebuy && claimStats2?.rebuy?.length > 0 ? (
                      <p>
                        <span></span>
                        {parseFloat(claimStats2?.rebuy[0]?.totalWbtc).toFixed(
                          5
                        )}{" "}
                        WBTC
                      </p>
                    ) : (
                      <p>
                        <span></span>0 WBTC
                      </p>
                    )}

                    {claimStats2?.rebuy && claimStats2?.rebuy?.length > 0 ? (
                      <p>
                        <span></span>
                        {parseFloat(claimStats2?.rebuy[0]?.totalUsdc).toFixed(
                          4
                        )}{" "}
                        USDC
                      </p>
                    ) : (
                      <p>
                        <span></span>0 USDC
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="inner-div">
                <div className="custom-option-field">
                  <input
                    type="search"
                    onChange={(e) => {
                      if (page != 0) {
                        setPage(0);
                      }
                      setTimeout(() => {
                        setSearch(e.target.value);
                      }, 2000);
                    }}
                    placeholder="Search..."
                  />
                  <img
                    src="\assets\search-icon.svg"
                    alt="img"
                    className="img-fluid search-icon"
                  />
                </div>
                {/* <div class="dropdown">
                  <button
                    onClick={() => setTypeFilter("")}
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Type
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li onClick={() => setTypeFilter("")}>
                      <a class="dropdown-item" href="#">
                        All Leaders
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("god_agent")}>
                      <a class="dropdown-item" href="#">
                        God Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("mega_agent")}>
                      <a class="dropdown-item" href="#">
                        Mega Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("super_agent")}>
                      <a class="dropdown-item" href="#">
                        Super Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("agent")}>
                      <a class="dropdown-item" href="#">
                        Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("mini_agent")}>
                      <a class="dropdown-item" href="#">
                        Ambassador
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="dropdown">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Status
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li
                      onClick={() => {
                        setStatusInf("");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        All
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setStatusInf("allowed");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        Allowed
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setStatusInf("pending");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        Pending
                      </a>
                    </li>
                  </ul>
                </div> */}
                {/* <div class="dropdown">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Allow Status
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="#">
                        Allowed
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#">
                        Pending
                      </a>
                    </li>
                  </ul>
                </div> */}

                <div class="dropdown set-custom-type-dropdown-mobile">
                  <button
                    // onClick={() => setTypeFilter("")}
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {typeFilter == "god_agent"
                      ? "God Leader"
                      : typeFilter == "mega_agent"
                      ? "Mega Leader"
                      : typeFilter == "super_agent"
                      ? "Super Leader"
                      : typeFilter == "agent"
                      ? "Leader"
                      : "Type"}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li onClick={() => setTypeFilter("")}>
                      <a class="dropdown-item" href="#">
                        All Leaders
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("god_agent")}>
                      <a class="dropdown-item" href="#">
                        God Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("mega_agent")}>
                      <a class="dropdown-item" href="#">
                        Mega Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("super_agent")}>
                      <a class="dropdown-item" href="#">
                        Super Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("agent")}>
                      <a class="dropdown-item" href="#">
                        Leader
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="dropdown">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {claimStatusFilter == "claimed"
                      ? "Claimed"
                      : claimStatusFilter == "unclaimed"
                      ? "Unclaimed"
                      : "Claim Status"}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setClaimStatusFilter("");
                        }}
                      >
                        All
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setClaimStatusFilter("claimed");
                        }}
                      >
                        Claimed
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setClaimStatusFilter("unclaimed");
                        }}
                      >
                        Unclaimed
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="dropdown">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {statusInf == "allowed"
                      ? "Allowed"
                      : statusInf == "pending"
                      ? "Pending"
                      : "Allow Status"}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li
                      onClick={() => {
                        setStatusInf("");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        All
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setStatusInf("allowed");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        Allowed
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setStatusInf("pending");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        Pending
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="dropdown sjcbvysvs mobile-btn d-none">
                <button
                  class="dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div>
                    {!codeBlockFilter
                      ? "Code Blocked"
                      : deletedFilter
                      ? "Soft Deleted"
                      : "All Leaders"}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid ms-2"
                    />
                  </div>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(true);
                        setDeletedFilter(false);
                      }}
                    >
                      All Leaders
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(false);
                        setDeletedFilter(false);
                      }}
                    >
                      Code Blocked
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setDeletedFilter(true);
                        setCodeBlockFilter(true);
                      }}
                    >
                      Soft Deleted
                    </a>
                  </li>
                </ul>
              </div>
              <div class="dropdown sjcbvysvs mobile-btn d-none">
                <button
                  class="dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div>
                    {!codeBlockFilter
                      ? "Code Blocked"
                      : deletedFilter
                      ? "Soft Deleted"
                      : "All Leaders"}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid ms-2"
                    />
                  </div>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(true);
                        setDeletedFilter(false);
                      }}
                    >
                      All Leaders
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(false);
                        setDeletedFilter(false);
                      }}
                    >
                      Code Blocked
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setDeletedFilter(true);
                        setCodeBlockFilter(true);
                      }}
                    >
                      Soft Deleted
                    </a>
                  </li>
                </ul>
              </div>
              <CSVLink
                className="download-table-xls-button  nnn mobile-btn d-none"
                data={claimsCSVData}
                headers={claimsCSVDataHeaders}
                filename={"ClaimsData.csv"}
              >
                Download CSV
              </CSVLink>
              {/* <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="download-table-xls-button  nnn mobile-btn d-none"
                table="table-to-xls"
                filename="tablexls"
                sheet="tablexls"
                buttonText="Download as CSV"
              /> */}
              <button
                disabled={selected?.length < 1}
                onClick={() => setSelected(true)}
                className={
                  selected?.length < 1
                    ? "allow-claim-btn mobile-btn d-none disable"
                    : "allow-claim-btn mobile-btn d-none"
                }
              >
                Allow All Claims
              </button>
              <button
                disabled={selected?.length < 1}
                onClick={() => setShow(true)}
                className={
                  selected?.length < 1
                    ? "allow-claim-btn mobile-btn d-none disable"
                    : "allow-claim-btn mobile-btn d-none"
                }
              >
                Allow Selected Claims
              </button>
              <button
                disabled={selected?.length < 1}
                onClick={() => revokeClaim()}
                className={
                  selected?.length < 1
                    ? "revoke-claim-btn mobile-btn d-none disable"
                    : "revoke-claim-btn mobile-btn d-none"
                }
              >
                Revoke Selected Claim
              </button>
              <DataTable
                setClaimsData={setClaimsData}
                claimsData={viewAll ? allclaimsData : claimsData}
                usdPrice={usdPrice}
                setSelected={setSelected}
                selected={selected}
                claimStats={claimStats}
                round={round}
                uptclaimset={uptClaim}
                checkBoxVal={Math.random()}
                tomiPrice={tomiPrice}
                loader={loader}
                btcPrice={btcPrice}
              />
            </div>
            {/******************  this DataTable is only for csv and it is display none ***************************/}
            {/* <DataTableCSV
              claimsData={allclaimsData}
              claimStats={claimStats}
              round={round}
              xlId={"table-to-xls"}
            /> */}
            {/******************  this DataTable is only for csv and it is display none ***************************/}
            <div className="d-flex">
              {/* <img src="\assets\claim\csv.svg" alt="" /> */}
              <div class="dropdown drop-allclaim">
                <button
                  class="dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div>
                    {!codeBlockFilter
                      ? "Code Blocked"
                      : deletedFilter
                      ? "Soft Deleted"
                      : "All Leaders"}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid ms-2"
                    />
                  </div>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(true);
                        setDeletedFilter(false);
                      }}
                    >
                      All Leaders
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(false);
                        setDeletedFilter(false);
                      }}
                    >
                      Code Blocked
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setDeletedFilter(true);
                        setCodeBlockFilter(true);
                      }}
                    >
                      Soft Deleted
                    </a>
                  </li>
                </ul>
              </div>
              <CSVLink
                className="download-table-xls-button  nnn desktop-btn"
                data={claimsCSVData}
                headers={claimsCSVDataHeaders}
                filename={"ClaimsData.csv"}
              >
                Download CSV
              </CSVLink>
              {/* <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="download-table-xls-button  nnn desktop-btn"
                table="table-to-xls"
                filename={`Round ${round} Leader Claims`}
                sheet="tablexls"
                buttonText="Download as CSV"
              /> */}
              <button
                disabled={selected?.length < 1}
                onClick={() => setShow(true)}
                className={
                  selected?.length < 1
                    ? "allow-claim-btn desktop-btn disable"
                    : "allow-claim-btn desktop-btn"
                }
              >
                Allow Selected Claims
              </button>
              <button
                disabled={selected?.length < 1}
                onClick={() => revokeClaim()}
                className={
                  selected?.length < 1
                    ? "revoke-claim-btn desktop-btn disable"
                    : "revoke-claim-btn desktop-btn"
                }
              >
                Revoke Selected Claim
              </button>
            </div>
          </div>
          <div className="footer-content mt-2 viewAll">
            <div className="left-f ">
              {viewAll ? (
                <h6 onClick={() => setViewAll(false)}>
                  View Paginated Entries
                </h6>
              ) : (
                <h6 onClick={() => setViewAll(true)}>Show All</h6>
              )}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
            </div>
            {viewAll || (
              <div className="right-f">
                <nav aria-label="Page navigation example">
                  <ul class="pagination">
                    <nav aria-label="Page navigation example">
                      {pageCount > 0 ? (
                        <ul class="text-center">
                          <ReactPaginate
                            previousLabel={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                              >
                                <path
                                  d="M10 13L5 8L10 3"
                                  stroke="#fff"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            }
                            nextLabel={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                              >
                                <path
                                  d="M5 13L10 8L5 3"
                                  stroke="#fff"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            }
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakLabel="..."
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageChange}
                            containerClassName="pagination"
                            activeClassName="active"
                            forcePage={page}
                          ></ReactPaginate>
                        </ul>
                      ) : null}
                    </nav>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </section>

      <Modal
        className="delete-modal global-modal-scss"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Allow Claim</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-modal-div">
            <h6>
              Are you sure you want to allow claim for the selected leader(s)
            </h6>
          </div>
          <div className="twice-btn">
            <button onClick={() => handleClose()} className="btn-cancel">
              Cancel
            </button>
            {/* handleClose(false);
            setShow2(true); */}
            <button
              className="btn-confirm"
              onClick={() => {
                allowClaim();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Allow Claim</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div scuhvscycvst">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="110"
              height="111"
              viewBox="0 0 110 111"
              fill="none"
            >
              <g clip-path="url(#clip0_40_7454)">
                <path
                  d="M33.4785 7.67383H21.522V14.8477H33.4785V7.67383Z"
                  fill="white"
                />
                <path
                  d="M21.522 14.8479H14.3481V22.0217H21.522V14.8479Z"
                  fill="white"
                />
                <path
                  d="M14.3477 22.0217H7.17383V33.9782H14.3477V22.0217Z"
                  fill="white"
                />
                <path
                  d="M14.3477 77.0217H7.17383V88.9782H14.3477V77.0217Z"
                  fill="white"
                />
                <path
                  d="M21.522 88.9783H14.3481V96.1521H21.522V88.9783Z"
                  fill="white"
                />
                <path
                  d="M33.4785 96.1521H21.522V103.326H33.4785V96.1521Z"
                  fill="white"
                />
                <path
                  d="M76.5215 0.5H33.478V7.67385H76.5215V0.5Z"
                  fill="white"
                />
                <path
                  d="M76.5215 103.326H33.478V110.5H76.5215V103.326Z"
                  fill="white"
                />
                <path
                  d="M7.17385 33.9783H0V77.0218H7.17385V33.9783Z"
                  fill="white"
                />
                <path
                  d="M88.4785 7.67383H76.522V14.8477H88.4785V7.67383Z"
                  fill="white"
                />
                <path
                  d="M95.6519 14.8479H88.478V22.0217H95.6519V14.8479Z"
                  fill="white"
                />
                <path
                  d="M102.826 22.0217H95.6519V33.9782H102.826V22.0217Z"
                  fill="white"
                />
                <path
                  d="M102.826 77.0217H95.6519V88.9782H102.826V77.0217Z"
                  fill="white"
                />
                <path
                  d="M95.6519 88.9783H88.478V96.1521H95.6519V88.9783Z"
                  fill="white"
                />
                <path
                  d="M88.4785 96.1521H76.522V103.326H88.4785V96.1521Z"
                  fill="white"
                />
                <path
                  d="M110 33.9783H102.826V77.0218H110V33.9783Z"
                  fill="white"
                />
                <path
                  d="M23.9131 38.7609H16.7393V53.1088H23.9131V38.7609Z"
                  fill="white"
                />
                <path
                  d="M45.4346 38.7609H38.2607V53.1088H45.4346V38.7609Z"
                  fill="white"
                />
                <path
                  d="M38.261 31.587H23.9131V38.7609H38.261V31.587Z"
                  fill="white"
                />
                <path
                  d="M71.7393 38.7609H64.5654V53.1088H71.7393V38.7609Z"
                  fill="white"
                />
                <path
                  d="M93.2608 38.7609H86.0869V53.1088H93.2608V38.7609Z"
                  fill="white"
                />
                <path
                  d="M86.0872 31.587H71.7393V38.7609H86.0872V31.587Z"
                  fill="white"
                />
                <path
                  d="M66.9564 88.9783H43.0435V96.1521H66.9564V88.9783Z"
                  fill="white"
                />
                <path
                  d="M74.1305 60.2827H35.8699H28.6958V67.4565V81.8044H35.8699V67.4565H74.1305V81.8044H81.3046V67.4565V60.2827H74.1305Z"
                  fill="white"
                />
                <path
                  d="M43.0435 81.8044H35.8696V88.9782H43.0435V81.8044Z"
                  fill="white"
                />
                <path
                  d="M74.1304 81.8044H66.9565V88.9782H74.1304V81.8044Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_40_7454">
                  <rect
                    width="110"
                    height="110"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            <h6>Claims Opened</h6>
          </div>
          <div className="twice-btn">
            <button
              className="btn-add"
              style={{ flex: "auto" }}
              onClick={handleClose2}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss claiming-modal"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Claiming</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="newclaiming-modal">
            <div className="left-side">
              <h6>Claiming Function (Admin)</h6>
              <p>
                This functions turns on or off the ability for the leaders to
                claim
              </p>
            </div>
            <div className="right-side">
              <div className="parent-toggle-switch-custom">
                <div class="custom-toggle">
                  <input
                    onChange={openClaim}
                    type="checkbox"
                    checked={claimStatus}
                    class="checkbox"
                    id="checkbox"
                  />
                  <label class="switch" for="checkbox">
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Claim;
